import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import Input from "../../../../ReusableComponents/Input/Input";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { useSelector } from "react-redux";
import {
  savePreviousState,
  validateChangeAtButton,
} from "../../../../utils/EditChangeValidate";

export default function AddEditFormNationality({
  submitForm,
  submitFormLoading,
  cancelForm,
  loadedValues = {},
  form = [],
}) {
  const [flag, setFlag] = useState("");
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);
  const [preName, setPreName] = useState(form[0].value);
  const [preCountryCode, setPreCountryCode] = useState(form[1].value);
  const [preMobileCode, setPreMobileCode] = useState(form[2].value);
  const [allowEdit, setAllowEdit] = useState(!loadedValues);
  const [prevState, setPrevState] = useState([]);

  useEffect(() => {
    if (loadedValues) {
      setPrevState(savePreviousState(form));
    }
  }, []);

  useEffect(() => {
    if (setPrevState) {
      const valid = validateChangeAtButton(prevState, form);
      if (valid || flag) setAllowEdit((p) => true);
      else setAllowEdit((p) => false);
    }
  }, [form, flag]);
  return (
    <div className="flex justify-center items-center bg-white dark:bg-dark rounded-md py-5">
      <form
        method="POST"
        onSubmit={(event) => submitForm(event, flag)}
        className="w-full  flex flex-col items-center justify-center"
      >
        {form.map((elem, index) => (
          <div key={index} className="flex flex-col p-2 gap-1 w-full max-w-md">
            <Input
              type={elem.type}
              name={elem.columnName}
              placeholder={`Enter ${elem.text}`}
              defaultValue={elem.value}
              onChange={(e) => elem.update(e.target.value?.toUpperCase())}
              component="nationality"
              label={elem.text}
              required
            />
          </div>
        ))}
        <div className="flex flex-col uppercase p-2 gap-1 w-full max-w-md">
          <label htmlFor={`addOrEdit-file`} className="text-xs ">
            {" "}
            Flag icon{" "}
          </label>
          <input
            type="file"
            name="file"
            id={`addOrEdit-file`}
            className="border-[1px] uppercase border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e) => {
              const errorElem = document.getElementById(
                "nationality-flag_icon"
              );
              errorElem.style.display = "none";
              setFlag(e.target.files[0]);
            }}
            required={!loadedValues}
          />
          <p
            id={`nationality-flag_icon`}
            className="hidden w-full h-5 bg-red/5 text-red text-xs"
          ></p>
        </div>

        <div className="p-2  w-full max-w-md flex gap-3">
          <button
            type="button"
            className="ring-1 ring-black uppercase dark:ring-red w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            disabled={submitFormLoading}
            onClick={cancelForm}
          >
            <p>Cancel</p>
          </button>
          {((!loadedValues &&
            checkAccess("Nationality", "nationality-create")) ||
            (loadedValues &&
              checkAccess("Nationality", "nationality-edit"))) && (
            <button
              type="submit"
              className={`${
                loadedValues && !allowEdit
                  ? "bg-gray uppercase cursor-not-allowed"
                  : "bg-black"
              } dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2`}
              disabled={submitFormLoading || (loadedValues && !allowEdit)}
              title={`${loadedValues && !allowEdit ? "No changes made" : ""}`}
            >
              <p>Submit</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
